import { Table, Flex } from '@radix-ui/themes';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UploadingRow } from './UploadingRow.jsx';
import { FileRow } from './FileRow.jsx';
import Sort from '../../../shared/Sort/Sort.jsx';

const sortableColumns = [
  { name: 'name', width: '280px' },
  { name: 'category', width: '230px' },
  { name: 'vendor', width: '300px' },
  { name: 'uploadDate', width: '150px' },
  { name: 'uploader', width: '150px' },
];

export const VaultTable = ({
  vaultFiles,
  uploadingFiles,
  categories,
  vendors,
  sortingStatus,
  changeSort,
}) => {
  const { t } = useTranslation('vault');
  const [editingId, setEditingId] = useState(null);

  return (
    <Table.Root>
      <Table.Header>
        <Table.Row style={{ verticalAlign: 'middle' }}>
          {sortableColumns.map(column => (
            <Table.ColumnHeaderCell
              key={column.name}
              width={column.width}
              style={{ cursor: 'pointer' }}
              onClick={() => changeSort(column.name)}
            >
              <Flex align="center" gap="2">
                <Sort sortingStatus={sortingStatus} columnName={column.name} />
                {t(`columns.${column.name}`)}
              </Flex>
            </Table.ColumnHeaderCell>
          ))}
          <Table.ColumnHeaderCell width="80px">
            {t('columns.actions')}
          </Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {uploadingFiles.map(file => {
          return <UploadingRow key={file.id} file={file} />;
        })}
        {vaultFiles.map(file => {
          const isEditing = editingId === file.id;

          return (
            <FileRow
              key={file.id}
              file={file}
              isEditing={isEditing}
              setEditingId={setEditingId}
              categories={categories}
              vendors={vendors}
            />
          );
        })}
      </Table.Body>
    </Table.Root>
  );
};
